// UserRoles is an immutable object that defines the roles available in the system.
export const UserRoles = Object.freeze({
  ADMIN: 'admin',
  EDITOR: 'editor',
  INFLUENCER: 'influencer',
  USER: 'user',
});
